module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-500.a4e11dda40531debd374.ttf";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-500.ttf
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-500.ttf
// module chunks = styles